<template>
  <div>
   
    <!---  
<v-row>
        <v-col>{{ this.variableItems}}</v-col>
    </v-row><v-row>
        <v-col>{{ this.chartFilter}}</v-col>
    </v-row><v-row>
        <v-col>{{ this.chartdataForchart}}</v-col>
    </v-row>
    <v-row>
        <v-col>======={{ this.chartsData}}</v-col>
    </v-row>
    <v-row class="mt-1" style="display:none !important;">
        <v-col cols="6"  align="left"><span style=" font-weight: bold;margin-left:10px;">Box-plot</span></v-col>
        <v-col cols="6">
            <v-select multiple v-model="chartFilter" :items="variableItems.filter(item => !['dv_sales', 'd_volume', 't_date'].includes(item))" outlined dense hide-details="auto" placeholder="select variables" chips small-chips></v-select>
        </v-col>

    </v-row>
    <v-row>
      <v-col>{{ this.chartdataForchartafterfilter }}  {{this.chartdataForchartnew}}</v-col>
    </v-row>-->
  
    <v-row class="d-flex justify-center">
      <v-col cols="12">
        <div id="chart">
          <apexChart
            type="boxPlot"
            height="450"
            :options="chartOptions"
            :series="chartsData"
          ></apexChart>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import apifactory from "../../api";
export default {
  props: {
    data: null,
    variablesforfilter: null,
  },
  components: {
    apexChart: VueApexCharts,
  },
  data() {
    return {
      chartdataForchart: [],
      chartdataForchartnew: [],
      chartdataForchartafterfilter: [],
      prevstepQueryStringParm: [],
      prevstepQueryStringParmUrl: "",

      variableItems: [],
      chartsData: [],
      chartFilter: null,

      // chartOptions: {
      //   chart: {
      //     height: 500,
      //     type: "bar",
      //     stacked: false,
      //     toolbar: {
      //       show: false,
      //     },
      //   },
      //   plotOptions: {
      //     bar: {
      //       borderRadius: 5,
      //       barHeight: '50%',
      //     },
      //   },
      //   dataLabels: {
      //     enabled: false,
      //   },
      //   stroke: {
      //     width: [1, 1],
      //   },
      //  /* title: {
      //     text: "XYZ - Stock Analysis (2009 - 2016)",
      //     align: "left",
      //     offsetX: 110,
      //   },*/
      //   xaxis: {
      //     categories: chartcategories,
      //     labels: {
      //       style: {
      //         colors: '#9AA1A9',
      //         fontWeight: 'bold'
      //       }
      //     }
      //   },
      //   yaxis: [
          
      //     { 
      //       axisTicks: {
      //         show: true,
      //       },
      //       labels: {
      //       style: {
      //         colors: ["#9AA1A9"],
      //         fontWeight: 'bold'
      //       },
      //     },
      //       title: {
      //         text: "CPP",
      //         style: {
      //           color: "#9AA1A9",
      //         },
      //       },
      //       tooltip: {
      //         enabled: true,
      //       },
      //     },
      //     {
      //       seriesName: "Income",
      //       opposite: true,
      //       axisTicks: {
      //         show: true,
      //       },
      //       labels: {
      //       style: {
      //         colors: ["#9AA1A9"],
      //         fontWeight: 'bold'
      //       },
      //     },
      //       title: {
      //         text: "Effective Frequency",
      //         style: {
      //           color: "#9AA1A9",
      //         },
      //       },
      //     },
      //   ],
      //   tooltip: {
      //     fixed: {
      //       enabled: true,
      //       position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
      //       offsetY: 30,
      //       offsetX: 60,
      //     },
      //   },
      //   legend: {
      //     fontWeight: 'bold',
      //     labels: {
      //       colors: '#9AA1A9',
      //     }
      //   },
      // };
      chartOptions: {
        chart: {
          type: "boxPlot",
          height: 250,
          fontFamily: "Lato",
        },
        plotOptions: {
          boxPlot: {
            colors: {
              upper: "#5C4742",
              lower: "#A5978B",
            },
          },
        },
        xaxis: {
          labels: {
            style: {
              colors: '#9AA1A9',
              fontWeight: 'bold'
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: ["#9AA1A9"],
              fontWeight: 'bold'
            },
          },
        }
      },
    };
  },
  methods: {
    getParametrOfPrvStep() {
      this.prevstepQueryStringParm = "";
      apifactory
        .gettheParameterByProjectStepSummary()
        .then((res) => {
          if (res.status != 200) {
            this.prevstepQueryStringParm = "";
            // alert(this.processdataitems.length);
          } else {
            this.prevstepQueryStringParm = res.data;
            let strurl = "";
            for (var k in this.prevstepQueryStringParm) {
              if (k != "step") {
                strurl =
                  strurl + k + "=" + this.prevstepQueryStringParm[k] + "&";
                // alert( this.prevstepQueryStringParm[k]);
              }
            }
            strurl = strurl.slice(0, -1);
            this.prevstepQueryStringParmUrl = strurl;

            this.fetchVaribles();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    fetchVaribles() {
      apifactory
        .get_sdataheaders()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            //alert(JSON.stringify(res.data));
            //this.variableItems = res.data;
            this.variableItems = [...Object.keys(res.data)];
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    fetchData() {
      //let url = `http://Mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/expl/?brand=xyz&level=national&time=date&competitor=comp1&country=india&sales_value=sales&sales_volume=volume&activity=non_clm_call,clm_call,webinar,mass_email,email_1to1,phone_call&start1=01-01-2020&end1=01-02-2020&start2=01-03-2020&end2=02-04-2020&start3=01-05-2020&end3=01-06-2020`;
      //this.$axios.get(url).then(response => (this.chartsData = response.data));

      apifactory
        .get_BoxPlotdata(this.prevstepQueryStringParmUrl)
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            //alert(JSON.stringify(res.data));
            //this.variableItems = res.data;
            this.chartsData = res.data;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    bindchart(varchartdata, varfilterforchart, varvaribalelist) {
      this.chartdataForchart = varchartdata;
      this.chartdataForchartnew=varchartdata;
      this.chartFilter = varfilterforchart;
      this.variableItems = varvaribalelist;
       let tempoutdata=[];
      for (let el in this.chartdataForchartnew) {
        // alert(this.series[el].name);
        for (let k in this.chartFilter) {
          //alert("dd"+this.chartsFilter[k]);
          if (
            this.chartdataForchartnew[el].variable ===
            this.chartFilter[k]
          ) {
            //alert(JSON.stringify(this.series[el]));

            tempoutdata.push(this.chartdataForchart[el]);
          }
        }
      }
      this.chartdataForchartafterfilter=tempoutdata;
      this.chartdataForchart=tempoutdata;
      this.chartsData = this.boxplotData();
    },
    boxplotData() {
      let res = [
        {
          data: [],
        },
      ];

      for (let el in this.chartdataForchart) {
        res[0].data.push({
          x: this.chartdataForchart[el]["variable"],
          y: [
            this.chartdataForchart[el]["min"],
            this.chartdataForchart[el]["Q1"],
            this.chartdataForchart[el]["median"],
            this.chartdataForchart[el]["Q3"],
            this.chartdataForchart[el]["max"],
          ],
        });
      }
      return res;
    },
  },
  /*
    computed: {
        boxplotData1() {
            let res = [{
                data: []
            }];

            for (let el in this.chartsData) {
                if (el === this.chartFilter) {
                    res[0].data.push({
                        x: el,
                        y: [
                            this.chartsData[el]["min"],
                            this.chartsData[el]["Q1"],
                            this.chartsData[el]["median"],
                            this.chartsData[el]["Q3"],
                            this.chartsData[el]["max"]
                        ]
                    });
                }
            }
            return res;
        },
        boxplotData2() {
            let res = [{
                data: []
            }];

            for (let el in this.chartsData) {
                for (let k in this.chartFilter) {
                    if (el === this.chartFilter[k]) {
                        res[0].data.push({
                            x: el,
                            y: [
                                this.chartsData[el]["min"],
                                this.chartsData[el]["Q1"],
                                this.chartsData[el]["median"],
                                this.chartsData[el]["Q3"],
                                this.chartsData[el]["max"]
                            ]
                        });
                    }
                }

            }
            return res;
        },
         boxplotData() {
            let res = [{
                data: []
            }];

            for (let el in this.chartsData) {
                res[0].data.push({
                            x: el,
                            y: [
                                this.chartsData[el]["min"],
                                this.chartsData[el]["Q1"],
                                this.chartsData[el]["median"],
                                this.chartsData[el]["Q3"],
                                this.chartsData[el]["max"]
                            ]
                        });

            }
            return res;
        },
        filteredChartsData() {
            let data = [];
            this.chartFilter.forEach(item => {
                data.push({
                    data: this.chartsData.map(el => el[item]),
                    name: item
                });
            });
            return data;
        }
    },
    mounted() {
        
       // this.getParametrOfPrvStep();
       
    },
    watch: {
        chartFilter(val) {
            if (val) {
                this.fetchData()
            }
        }
    }*/
};
</script>

<style>
</style>
